
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3dd32756\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./monthly_city_collection_reports.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./monthly_city_collection_reports.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3dd32756\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./monthly_city_collection_reports.vue"),
  /* scopeId */
  "data-v-3dd32756",
  /* cssModules */
  null
)
Component.options.__file = "/home/ubuntu/wastemanagement/src/components/views/wasteReports/monthly_city_collection_reports.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] monthly_city_collection_reports.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3dd32756", Component.options)
  } else {
    hotAPI.reload("data-v-3dd32756", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/wasteReports/monthly_city_collection_reports.vue
// module id = 2233
// module chunks = 0